
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.167 1.833l-4 .334v3.666h12v8.334H1.833V1.833h4.334zm7.666 8.31H6.166v3.69h7.667v-3.69zm-8 0l-3.666.001v3.69h3.665v-3.69zm8-3.977H6.166v3.667h7.667V6.166zm-8 0H2.166v3.667h3.665V6.166zm8.334-4.333v2.334H7.833V1.833h6.334z","fill":"#2A333D","stroke":"#2A333D","fill-rule":"evenodd"}})])
          )
        }
      }
    